/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { QUESTIONS as QUESTIONS_CONST } from "../../../utils";

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({ questionnaire, idProduct, isLloydsOrLima, setGenerateMRC2 }) {
  questionnaire.sort((a, b) => a.idQuestion - b.idQuestion);

  let showConnectionQst = false;

  questionnaire = questionnaire.map((question) => {
    if (question.idQuestion === QUESTIONS_CONST.MRC2_Custom) {
      if (idProduct === 47 && !isLloydsOrLima) {
        question.disabled = true;
      } else if (isLloydsOrLima) {
        const filterOption = question.answerOptions?.find(opt => opt.idAnswerOption === 7596);
        if (filterOption) {
          question.answer = filterOption.dsAnswerOption;
          question.idAnswerOption = filterOption.idAnswerOption;
        }        
      }
      showConnectionQst = question.idAnswerOption === 7596;
    }

    if (question.idQuestion === QUESTIONS_CONST.MRC2_Connection && showConnectionQst) {
      const filterOption = question.answerOptions?.find(opt => opt.idAnswerOption === 7598);
      question.visibleQuestion = 1;
      if (filterOption && question.answerJson === '') {
        question.answer = filterOption.dsAnswerOption;
        question.idAnswerOption = filterOption.idAnswerOption;
      }
      setGenerateMRC2(question.idAnswerOption === 7598)
    }

    if (question.idQuestion === QUESTIONS_CONST.BROKERAGE_PAGE) {
      question.visibleQuestion = showConnectionQst ? 0 : 1;
      const filterOption = question.answerOptions?.find(opt => opt.idAnswerOption === ( !showConnectionQst ? 7606 : 7605));
      if (filterOption && !showConnectionQst && question.answerJson === '') {
        question.answer = filterOption.dsAnswerOption;
        question.idAnswerOption = filterOption.idAnswerOption;
        setGenerateMRC2(question.idAnswerOption === 7606);
      }
    }

    return question;
  })

  return questionnaire;
}

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  setGenerateMRC2,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete
}) {
  try {
    let saveQuestionnaire = false;

    const newQuestionnaireAnswersToDelete = []
    const newDocumentsToDelete = []

    if (question.idQuestion === 1944) {
      saveQuestionnaire = true;
      const showConnectionQst = value.idAnswerOption !== 7595;

      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if ([1945].includes(qst.idQuestion)) {

          const selectedOption = qst.answerOptions?.find((opt) => opt.idAnswerOption === (showConnectionQst ? 7598 : 7597));
          
          if (selectedOption) {
            qst.answer = qst.answerJson = selectedOption.dsAnswerOption;
            qst.idAnswerOption = selectedOption.idAnswerOption;
            setFieldValue(qst.key, selectedOption.dsAnswerOption);
          }
          qst.visibleQuestion = showConnectionQst;
          setGenerateMRC2(showConnectionQst);
        }

        if ([1950].includes(qst.idQuestion)) {
          qst.visibleQuestion = value?.idAnswerOption === 7595;
        }

        if ([1962].includes(qst.idQuestion)) {
          const showAttachment = questionnaireUpdated.find(qst => qst.idQuestion === 1945)?.idAnswerOption === 7597;
          qst.visibleQuestion = value?.idAnswerOption !== 7595 && showAttachment;
          qst.hiddenInput = false;

          if (!qst.visibleQuestion) {

            if (qst.idQuestionnaireAnswers) {
              newQuestionnaireAnswersToDelete.push(qst.idQuestionnaireAnswers);
            }

            const attachment = qst?.answer?.length ? qst?.answer[0] : null;
            if (attachment) {
              newDocumentsToDelete.push(attachment.documentId)
            }

            qst.answer = null;
            qst.idAnswerOption = null;
            qst.answerJson = null;
            setFieldValue(qst.key, []);
          }
        }

        return qst
      })
    }

    if (question.idQuestion === 1945) {
      saveQuestionnaire = true;

      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if ([1962].includes(qst.idQuestion)) {
          qst.visibleQuestion = value?.idAnswerOption !== 7598;
          qst.hiddenInput = false;

          if (!qst.visibleQuestion) {
            if (qst.idQuestionnaireAnswers) {
              newQuestionnaireAnswersToDelete.push(qst.idQuestionnaireAnswers);
            }

            const attachment = qst?.answer?.length ? qst?.answer[0] : null;
            if (attachment) {
              newDocumentsToDelete.push(attachment.documentId)
            }

            qst.answer = null;
            qst.idAnswerOption = null;
            qst.answerJson = null;
            setFieldValue(qst.key, []);
          }

          setGenerateMRC2(value.idAnswerOption === 7598);
        }

        return qst
      })
    }

    if(question.idQuestion === 1950) {
      setGenerateMRC2(value.idAnswerOption === 7606);
    }

    if (newQuestionnaireAnswersToDelete.length) {
      setQuestionnaireAnswersToDelete([
        ...questionnaireAnswersToDelete,
        ...newQuestionnaireAnswersToDelete
          .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers)
          .filter((idQuestionnaireAnswers) => !questionnaireAnswersToDelete.includes(idQuestionnaireAnswers))
      ]);
    }

    if (newDocumentsToDelete.length) {
      setDocumentsToDelete([
        ...documentsToDelete,
        ...newDocumentsToDelete
          .filter((documentId) => !documentsToDelete.includes(documentId))
      ]);
    }

    if (saveQuestionnaire) setQuestionnaire(questionnaireUpdated)
  } catch (e) {
    console.log('MRC2 - handleQuestionChange - error', e);
  }
}


const events = {
  handleInitialAdjustments,
  handleQuestionChange
};

export { events };